import React, {useEffect, useRef, useState, useContext} from 'react';
import {useHistory} from "react-router-dom";
import {withRouter} from 'react-router';
import {downloadAPI, getAPI, patchAPI, postAPI, putAPI} from "../../APIUtil";
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css'
import AppNav from "../AppNav";
import {sortCaret} from "../../MdDataTable";
import {Card, Col, Container, Form, Row} from "react-bootstrap";
import {
  nvl,
  addField,
  parseDate,
  useDebounce,
  dateformatDB,
  dateformatDatePicker,
  toSingleByteNumberOnly,
  onFocusText,
  dateformatJPNMMDD,
  toNull,
  finishLoadingBtn, startLoadingBtn, checkKey, dateformatYYYY_MM_DD, dateformatYYYY_MM, focusById,
} from "../../CMUtil";
import Button from "react-bootstrap/Button";
import DatePicker, {registerLocale} from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css";
import FormCheckLabel from "react-bootstrap/FormCheckLabel";
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory from "react-bootstrap-table2-editor";
import Toast, {error, success} from "../../Toast";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCalendar, faFile, faFileDownload, faFileExcel, faList} from "@fortawesome/free-solid-svg-icons";
import {GlobalContext} from "../../Global";


export const PayGrpList = ({pIsModal, pPayGrpType, pPayDate, setPayGrpNum, setPayGrpModalShow}) => {

  const {loginUser, setLoginUser} = useContext(GlobalContext);

  const history = useHistory();
  const iniSearch = useRef(true);

  const [locPage, setLocPage] = useState(null);
  const [locSizePerPage, setLocSizePerPage] = useState(null);
  const [locTotalSize, setLocTotalSize] = useState(null);
  const [locSortField, setLocSortField] = useState(null);
  const [locSortOrder, setLocSortOrder] = useState(null);

  const [payGrpType, setPayGrpType] = useState("");
  const debouncedPayGrpType = useDebounce(payGrpType, 500, setLocPage);
  const [payDate, setPayDate] = useState("");
  const debouncedPayDate = useDebounce(payDate, 500, setLocPage);
  const [note, setNote] = useState("");
  const [payGrpSelectedOnly, setPayGrpSelectedOnly] = useState(false);
  const debouncedPayGrpSelectedOnly = useDebounce(payGrpSelectedOnly, 500, setLocPage);

  const [searchCount, setSearchCount] = useState("");

  const [listData, setListData] = useState([]);

  // 項目定義
  const columns = [
    {
      dataField: 'pay_date',
      text: '支払日',
      classes: 'tbl-col text-center',
      sort: true,
      editable: false,
      headerStyle: {width: '130px', textAlign: "center"},
      sortCaret: (order, column) => {
        return sortCaret(order, column);
      }
    },
    {
      dataField: 'pay_grp_num',
      text: 'Gno',
      classes: 'tbl-col text-center',
      sort: true,
      editable: false,
      headerStyle: {width: '40px', textAlign: "center"},
      sortCaret: (order, column) => {
        return sortCaret(order, column);
      }
    },
    {
      dataField: 'note',
      text: 'メモ',
      classes: 'tbl-col col-editable ml-1 mr-1',
      sort: true,
      headerStyle: {textAlign: "center"},
      editCellClasses: 'tbl-col-editing',
      sortCaret: (order, column) => {
        return sortCaret(order, column);
      }
    },
    {
      dataField: 'pay_grp_num_icon',
      isDummyField: true,
      text: '一覧',
      classes: 'tbl-col text-center',
      sort: true,
      editable: false,
      headerStyle: {width: '60px', textAlign: "center"},
      sortCaret: (order, column) => {
        return sortCaret(order, column);
      },
      style: {
        padding: '0',
        // fontSize: "1.2rem",
        verticalAlign: "middle",
        color: "#0058a0"
      },
      formatter: (cell, row) => (
        <div>
          <FontAwesomeIcon icon={faList} size="lg" onClick={e => onClickToList(row)} style={{cursor: "pointer", fontWeight: "bold"}}/>
        </div>
      )
    },
    {
      dataField: 'pay_grp_id',
      text: '支払集計表',
      classes: 'tbl-col text-center',
      sort: true,
      editable: false,
      hidden: pIsModal,
      headerStyle: {width: '120px', textAlign: "center"},
      style: {
        padding: '0',
        // fontSize: "1.2rem",
        verticalAlign: "middle",
        color: "#0058a0"
      },
      sortCaret: (order, column) => {
        return sortCaret(order, column);
      },
      formatter: (cell, row) => (
        <FontAwesomeIcon icon={faFile} size="lg" onClick={e => onClickDownload(row.pay_grp_id)} style={{cursor: "pointer"}}/>
      )
    },
    {
      dataField: 'pay_notice_create_date',
      text: '支払案内書',
      classes: 'tbl-col text-center',
      sort: true,
      editable: false,
      hidden: pIsModal,
      headerStyle: {width: '120px', textAlign: "center"},
      sortCaret: (order, column) => {
        return sortCaret(order, column);
      },
      formatter: (cell, row) => (
        cell && <span>{dateformatJPNMMDD(parseDate(cell))}</span>
      )
    },
    {
      dataField: 'fb_data_create_date',
      text: 'ＦＢ作成',
      classes: 'tbl-col text-center',
      sort: true,
      editable: false,
      hidden: pIsModal,
      headerStyle: {width: '120px', textAlign: "center"},
      sortCaret: (order, column) => {
        return sortCaret(order, column);
      },
      formatter: (cell, row) => (
        cell && <span>{dateformatJPNMMDD(parseDate(cell))}</span>
      )
    },
    {
      dataField: 'acc_data_create_date',
      text: '会計作成',
      classes: 'tbl-col text-center',
      sort: true,
      editable: false,
      hidden: pIsModal,
      headerStyle: {width: '120px', textAlign: "center"},
      sortCaret: (order, column) => {
        return sortCaret(order, column);
      },
      formatter: (cell, row) => (
        cell && <span>{dateformatJPNMMDD(parseDate(cell))}</span>
      )
    },
    {
      dataField: 'pay_finalize_date',
      text: '支払確定',
      classes: 'tbl-col text-center',
      sort: true,
      editable: false,
      hidden: pIsModal,
      headerStyle: {width: '120px', textAlign: "center"},
      sortCaret: (order, column) => {
        return sortCaret(order, column);
      },
      formatter: (cell, row) => (
        cell && <span>{dateformatJPNMMDD(parseDate(cell))}</span>
      )
    },
    {
      dataField: 'exp_tran_create_date',
      text: '支払実施',
      classes: 'tbl-col text-center',
      sort: true,
      editable: false,
      hidden: pIsModal,
      headerStyle: {width: '120px', textAlign: "center"},
      sortCaret: (order, column) => {
        return sortCaret(order, column);
      },
      formatter: (cell, row) => (
        <Button className="p-0 btn-make-exp-tran" variant={cell ? 'primary' : 'primary'} onClick={e => onClickExecPay(row.pay_grp_id, row.pay_grp_type)}>
          {cell ? '再送信' : '送信'}
        </Button>
      )
    }
  ];

  // 初期化
  useEffect(() => {

    if(loginUser.dept !== '経理' && loginUser.dept !== 'システム'){
      history.push('/item_list/');
      return;
    }

    const init = async () => {

      if (pPayGrpType && pPayDate) {
        setPayGrpTypeSearch(pPayGrpType);
        setPayDateSearch(pPayDate);
      } else {
        let pay_search_condition = localStorage.getItem("pay_grp_search_condition");
        if (pay_search_condition) {
          // 前回検索条件から検索
          let s = JSON.parse(pay_search_condition);
          s.pay_grp_type ? setPayGrpTypeSearch(s.pay_grp_type) : null;
          s.pay_date ? setPayDateSearch(s.pay_date) : null;
        } else {
          setPayGrpTypeSearch("原稿料");
        }
      }

      if (!history.location.state) {
        setLocPage(1);
      } else if (!history.location.state.pages) {
        setLocPage(1);
      } else if (!history.location.state.pages.filters) {
        setLocPage(1);
      } else if (Object.keys(history.location.state.pages.filters).length === 0) {
        setLocPage(1);
      } else {
        setLocPage(history.location.state.pages.page);
        setLocSizePerPage(history.location.state.pages.sizePerPage);
        setLocSortField(history.location.state.pages.sortField);
        setLocSortOrder(history.location.state.pages.sortOrder);
      }
    }
    init();
  }, []);

  // 検索処理
  useEffect(() => {
    if (iniSearch.current) {
      iniSearch.current = false;
      return;
    }
    const update = async () => {
      let searchCondition = {};
      addField(searchCondition, "page", locPage);
      addField(searchCondition, "size_per_page", locSizePerPage);
      addField(searchCondition, "sort_field", locSortField);
      addField(searchCondition, "sort_order", locSortOrder);
      addField(searchCondition, "pay_date", dateformatDB(payDate));
      addField(searchCondition, "pay_grp_type", payGrpType);
      // addField(searchCondition, "note", note);
      if (payGrpSelectedOnly) {
        addField(searchCondition, "selected", payGrpSelectedOnly);
      }
      localStorage.setItem("pay_grp_search_condition", JSON.stringify(searchCondition)); // 検索条件保持
      const res = await getAPI("ms_pay_grp_search_view", searchCondition);
      if (res.count > 0) {
        for (let i = 0; i < res.results.length; i++) {
          if (!res.results[i].note) {
            res.results[i].note = "";
            res.results[i].is_updated = false;
          }
        }
      }
      setListData(res.results);
    }
    update();
  }, [
    searchCount,
    locPage,
    locSizePerPage,
    locSortField,
    locSortOrder,
    debouncedPayDate,
    debouncedPayGrpType,
    // debouncedNote,
    debouncedPayGrpSelectedOnly
  ]);

  const setPayDateSearch = (value) => {
    setLocPage(1);
    setPayDate(value);
  }

  const setPayGrpTypeSearch = (value) => {
    setLocPage(1);
    setPayGrpType(value);
  }

  const updateNote = async (payGrpId, note) => {
    let obj = {};
    obj.note = note;
    obj.update_pg = "PayGrpList";
    //更新
    await patchAPI("ms_pay_grp/" + payGrpId + "/", obj);
  }

  const onClickExecPay = async (payGrpId, payGrpType) => {
    // 支払明細トランへの書込み
    let obj = {};
    obj.pay_grp_id = payGrpId;
    obj.pay_grp_type = payGrpType;
    let res = await postAPI("if_pay_dtl_tran_custom_view", obj);

    setSearchCount(payGrpId + "onClickExecPay");
    success("ステータスを更新しました");
  }

  const onClickDownload = async (payGrpId) => {

    let condition = {};
    let sortField = locSortField;
    let sortOrder = locSortOrder;

    addField(condition, "page", locPage);
    addField(condition, "size_per_page", 99999);
    addField(condition, "sort_field", sortField);
    addField(condition, "sort_order", sortOrder);
    addField(condition, "pay_grp_id", payGrpId);

    startLoadingBtn("btn-download");
    await downloadAPI("download/pay_sum_list", condition);
    finishLoadingBtn("btn-download");
  }

  const onClickToList = async (row) => {
    if(row.pay_grp_type === "原稿料"){
      history.push("/pay_list/?pay_date_from=" + row.pay_date +"&pay_date_to=" + row.pay_date + "&pay_grp_num=" + row.pay_grp_num + "&prv_url=/pay_grp_list/");
    }else if(row.pay_grp_type === "経費"){
      history.push("/exp_list/?pay_date_from=" + row.pay_date +"&pay_date_to=" + row.pay_date + "&pay_grp_num=" + row.pay_grp_num + "&prv_url=/pay_grp_list/");
    }else if(row.pay_grp_type === "印税"){
      history.push("/roy_list/?pay_date_from=" + row.pay_date +"&pay_date_to=" + row.pay_date + "&pay_grp_num=" + row.pay_grp_num + "&prv_url=/pay_grp_list/");
    }
  }

  // カレンダー用 ////////////////////////////////////////////////////////////////////////////////////////
  const [openCalPayDate, setOpenCalPayDate] = useState(false);
  const handleChangeCalPayDate = async (dateObj) => {
    setPayDate(dateformatYYYY_MM_DD(dateObj))
    setOpenCalPayDate(false);
    await focusById("payDate");
  };

  return (
    <>
      {!pIsModal &&
        <AppNav/>
      }
      <div id="pay-grp-list" style={{width: pIsModal ? "1150px" : "1400px", margin: "0px auto"}}>
        <Row className="h1">
          <Col sm="4">
            <h1>
              支払ステータス
            </h1>
          </Col>
        </Row>
        <Card className="card-search">
          <Container className="container-main-search">
            <Form.Group as={Row}>
              <Form.Label column sm="1">種別</Form.Label>
              <Col sm="4">
                <FormCheckLabel className={payGrpType === "原稿料" ? "form-check-label-checked-01" : ""}>
                  <Form.Check
                    type="radio"
                    id="payGrpType1"
                    name="payGrpType"
                    style={{marginRight: "1rem", display: "none"}}
                    checked={payGrpType === "原稿料"}
                    onChange={e => setPayGrpTypeSearch("原稿料")}
                  />
                  原稿料
                </FormCheckLabel>
                <FormCheckLabel className={payGrpType === "経費" ? "form-check-label-checked-01" : ""}>
                  <Form.Check
                    type="radio"
                    id="payGrpType2"
                    name="payGrpType"
                    style={{marginRight: "1rem", display: "none"}}
                    checked={payGrpType === "経費"}
                    onChange={e => setPayGrpTypeSearch("経費")}
                  />
                  経費
                </FormCheckLabel>
                <FormCheckLabel className={payGrpType === "印税" ? "form-check-label-checked-01" : ""}>
                  <Form.Check
                    type="radio"
                    id="payGrpType3"
                    name="payGrpType"
                    style={{marginRight: "1rem", display: "none"}}
                    checked={payGrpType === "印税"}
                    onChange={e => setPayGrpTypeSearch("印税")}
                  />
                  印税
                </FormCheckLabel>
              </Col>
              <Form.Label column sm="1">支払日</Form.Label>
              <Col sm="2" className="input-group">
                <div className="input-group" style={{width: "163px"}}>
                  <Form.Control
                    id="payDate"
                    type="text"
                    className="text-center"
                    inputMode="numeric"
                    tabIndex={2}
                    value={payDate}
                    onKeyPress={e => checkKey(e, /^[\d-]+$/)}
                    onChange={e => setPayDate(e.target.value)}
                    onFocus={e => onFocusText(e)}
                    onBlur={e => setPayDate(dateformatYYYY_MM_DD(dateformatDatePicker(e.target.value)))}
                  />
                  <button
                    type="button"
                    onClick={e => setOpenCalPayDate(true)}
                    style={{
                      position: "absolute",
                      top: "0.4rem",
                      right: "0.2rem",
                      border: "none",
                      background: "transparent",
                      cursor: "pointer",
                      zIndex: 5
                    }}>
                    <FontAwesomeIcon icon={faCalendar}/>
                  </button>
                </div>
                <DatePicker
                  selected={dateformatDatePicker(toSingleByteNumberOnly(payDate))}
                  onChange={handleChangeCalPayDate}
                  open={openCalPayDate}
                  onClickOutside={e => setOpenCalPayDate(false)}
                  customInput={<div style={{display: "none"}}/>}
                  dateFormat="yyyy-MM-dd"
                  popperPlacement="bottom-start"
                  disabledKeyboardNavigation
                  locale="ja"
                />
              </Col>
            </Form.Group>
          </Container>
        </Card>

        <Container className="container-main-list">
          <BootstrapTable
            keyField="pay_grp_id"
            data={listData}
            classes="dm-datatable"
            striped={true}
            columns={columns}
            cellEdit={cellEditFactory({
              mode: 'click',
              blurToSave: true,
              afterSaveCell: async (oldValue, newValue, row, column) => {
                if (oldValue !== newValue) {
                  await updateNote(row.pay_grp_id, newValue);
                }
              }
            })}
          />
        </Container>
        <Toast/>
      </div>
    </>
  );
}

export default withRouter(PayGrpList);